import { DqlQuery, Query } from '../field';

export class CustomStatistics {

  readonly id: Query.OrderField;
  readonly name: Query.OrderField;
  readonly externalId: Query.OrderField;

  constructor(prefix?: string) {
    prefix = prefix ? prefix : '';
    this.id = new DqlQuery.OrderField(prefix + 'id');
    this.name = new DqlQuery.OrderField(prefix + 'name');
    this.externalId = new DqlQuery.OrderField(prefix + 'external_id');
  }

}
